<template>
	<div>
		<h3 class="heading">Your selections</h3>
		<table class="product-selections">
			<thead>
				<tr class="product-selections__row product-selections__row--heading">
					<th class="product-selections__cell product-selections__cell--heading">Item</th>
					<th class="product-selections__cell product-selections__cell--heading">Qty</th>
					<th class="product-selections__cell product-selections__cell--heading">Price</th>
					<th class="product-selections__cell product-selections__cell--heading">+VAT</th>
					<th class="product-selections__cell product-selections__cell--heading"></th>
				</tr>
			</thead>
			<tbody>
				<tr class="product-selections__row product-selections__row--product">
					<td class="product-selections__cell product-selections__cell--item" colspan="5">{{ rangeProp }} {{ productProp }}</td>
				</tr>
				<tr class="product-selections__row product-selections__row--finish">
					<td class="product-selections__cell product-selections__cell--item product-selections__cell--finish">{{ finishSelectedProp.title }}{{ finishSelectedProp.inStock ? ', in stock':'' }}:</td>
					<td class="product-selections__cell" colspan="1"></td>
					<td class="product-selections__cell product-selections__cell--pricenovat">£{{ finishSelectedProp.price }}</td>
					<td class="product-selections__cell product-selections__cell--priceplusvat">£{{ finishSelectedProp.pricePlusVat }}</td>
					<td class="product-selections__cell product-selections__cell--remove"></td>
				</tr>
				<tr v-if="valveSelectedProp.price" class="product-selections__row product-selections__row--finish">
					<td class="product-selections__cell product-selections__cell--item product-selections__cell--finish">{{ valveSelectedProp.title }}:</td>
					<td class="product-selections__cell" colspan="1"></td>
					<td class="product-selections__cell product-selections__cell--pricenovat">£{{ valveSelectedProp.price }}</td>
					<td class="product-selections__cell product-selections__cell--priceplusvat">£{{ valveSelectedProp.pricePlusVat }}</td>
					<td class="product-selections__cell product-selections__cell--remove"></td>
				</tr>
				<tr v-if="supplementaryHeaterProp" class="product-selections__row product-selections__row--finish">
					<td class="product-selections__cell product-selections__cell--item product-selections__cell--finish">{{ supplementaryHeaterProp.title }}:</td>
					<td class="product-selections__cell" colspan="1"></td>
					<td class="product-selections__cell product-selections__cell--pricenovat">£{{ supplementaryHeaterProp.price }}</td>
					<td class="product-selections__cell product-selections__cell--priceplusvat">£{{ supplementaryHeaterProp.pricePlusVat }}</td>
					<td class="product-selections__cell product-selections__cell--remove"></td>
				</tr>

				<AcessorySummary v-for="accessory in accessoriesSelectedProp" :key="accessory.id" 
				:accessory="accessory"
				@accessoryQtyChanged="accessoryQtyChanged"
				@accessoryRemoved="accessoryRemoved"/>

				<tr v-if="parseFloat(surchargeTotal) > 0" class="product-selections__row product-selections__row--finish">
					<td class="product-selections__cell product-selections__cell--item product-selections__cell--finish">Surcharge:</td>
					<td class="product-selections__cell"></td>
					<td class="product-selections__cell product-selections__cell--pricenovat">£{{ surchargeTotal }}</td>
					<td class="product-selections__cell product-selections__cell--priceplusvat">£{{ surchargeTotalPlusVat }}</td>
					<td class="product-selections__cell product-selections__cell--remove"></td>
				</tr>
			</tbody>
			<tfoot>
				<tr class="product-selections__row product-selections__row--footer">
					<td class="product-selections__cell product-selections__cell--total">Total:</td>
					<td class="product-selections__cell"></td>
					<td class="product-selections__cell product-selections__cell--pricenovat product-selections__cell--pricenovat-total">£{{ totalPrice }}</td>
					<td class="product-selections__cell product-selections__cell--priceplusvat product-selections__cell--priceplusvat-total">£{{ totalPricePlusVat }}</td>
					<td class="product-selections__cell product-selections__cell--remove"></td>
				</tr>
			</tfoot>
		</table>
	</div>
</template>


<script>
	import FinishGroup from './FinishGroup.vue';
	import AcessorySummary from './AcessorySummary.vue';

	export default {
			props: ['productProp', 'rangeProp', 'finishSelectedProp', 'valveSelectedProp', 'supplementaryHeaterProp', 'accessoriesSelectedProp', 'accessoriesQuantitiesProp'],
			data() {
				return {
					finishSelected: null,
					accessoriesSelected: [],
					totalPrice: 0,
					totalPricePlusVat: 0
				};
			},
			components: {
				FinishGroup,
				AcessorySummary,
			},
			beforeMount() {
				this.accessoryQuantity;
				this.setTotalPrice();
				this.setTotalPricePlusVat();
			},
			methods: {
				accessoryRemoved: function(accessory) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();

					this.$emit('accessoryRemoved', accessory);
				},
				accessoryQtyChanged: function(accessory) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();

					if (accessory.qty < 1) {
						this.accessoryRemoved(accessory);
					} else {
						this.$emit('accessoryQtyChanged', accessory);
					}
				},
				updateTotalPrice: function() {
					this.setTotalPrice();
				},
				updateTotalPricePlusVat: function() {
					this.setTotalPricePlusVat();
				},
				setTotalPrice: function() {
					let total = parseFloat(this.finishSelectedProp.price);

					total = total + parseFloat(this.finishSelectedProp.surcharge);
					total = total + parseFloat(this.valveSelectedProp.price);
					total = this.supplementaryHeaterProp ? total + parseFloat(this.supplementaryHeaterProp.price) : total;
					this.accessoriesSelectedProp.forEach(accessory => {
						total = accessory.qtyPrice ? total + parseFloat(accessory.qtyPrice) : total + parseFloat(accessory.price);
					});

					this.totalPrice = total.toFixed(2);
				},
				setTotalPricePlusVat: function() {
					let total =  parseFloat(this.finishSelectedProp.pricePlusVat);

					total = total + parseFloat(this.finishSelectedProp.surchargePlusVat);
					total = total + parseFloat(this.valveSelectedProp.pricePlusVat);
					total = this.supplementaryHeaterProp ? total + parseFloat(this.supplementaryHeaterProp.pricePlusVat) : total;
					this.accessoriesSelectedProp.forEach(accessory => {
						total = accessory.qtyPricePlusVat ? total + parseFloat(accessory.qtyPricePlusVat) : total + parseFloat(accessory.pricePlusVat);
					});

					this.totalPricePlusVat = total.toFixed(2);
				}
			},
			watch: {
				finishSelectedProp: function(newV, oldV) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();
				},
				accessoriesSelectedProp: function(newV, oldV) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();
				},
				supplementaryHeaterProp: function(newV, oldV) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();
				},
				valveSelectedProp: function(newV, oldV) {
					this.updateTotalPrice();
					this.updateTotalPricePlusVat();
				}
			},
			computed: {
				surchargeTotal: function() {
					return 0; // hide surcharge for now
					let total = parseFloat(this.finishSelectedProp.surcharge);
					total = total + parseFloat(this.valveSelectedProp.surcharge);
					total = this.supplementaryHeaterProp ? total + parseFloat(this.supplementaryHeaterProp.surcharge) : total;
					this.accessoriesSelectedProp.forEach(accessory => {
						total = total + parseFloat(accessory.surcharge);
					});
					return total.toFixed(2);
				},
				surchargeTotalPlusVat: function() {
					return 0; // hide surcharge for now
					let total = parseFloat(this.finishSelectedProp.surchargePlusVat);
					total = total + parseFloat(this.valveSelectedProp.surchargePlusVat);
					total = this.supplementaryHeaterProp ? total + parseFloat(this.supplementaryHeaterProp.surchargePlusVat) : total;
					this.accessoriesSelectedProp.forEach(accessory => {
						total = total + parseFloat(accessory.surchargePlusVat);
					});
					return total.toFixed(2);
				},
				accessoryQuantity: function() {
					this.accessoriesSelectedProp.forEach((accessory) => {
						// Find accessory quantity prop with same id as accessory
						let qtyProp = this.accessoriesQuantitiesProp.find(aqp => aqp.id === accessory.id);

						accessory.qty = qtyProp.qty;
					});
				}
			}
	};
</script>

<style scoped>
	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}

	.product-selections {
		width: 100%;
		font-size: 14px;
		color: #333;
		border-collapse: collapse;
	}

	thead {
		background: #eee;
	}

	th,
	td {
		padding: 9px 18px;
		text-align: left;
		border-bottom: 1px solid #eee;
	}
</style>